;(function ( $ ) {

    /**
     *  toggleOptionalRows
     *  show/hide optional rows in form when checkbox changes
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'toggleOptionalRows';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.$form = $(this.element).parents('form');
            this.$checkbox = $(this.element).find('input[type="checkbox"]');
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            this.$checkbox.on('change', function(e) {
                if ($(this).prop('checked')) {
                    _this.$form.find('.optional-row').removeClass('is-hidden');
                } else {
                    _this.$form.find('.optional-row').addClass('is-hidden');
                }
                $(window).trigger('atp-form.rowtoggle');
            });
        }

    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
